import { Rate } from "../rate-type";
import { RateLocationMapper } from "./rate-location.mapper";
import { RateLocationBase } from "./rate-location-base.model";
import { Location } from "../../location/location.model";
import { RateLocation } from "./rate-location.type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";

export class LclRateLocation extends RateLocationBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected location: Location,
    protected comment: string,
    protected rate: Rate,
    protected minPrice: number,
    protected weightPrice: number,
    protected measurementPrice: number,
    protected blPrice: number,
    protected parent: RateLocation,
    protected excludedOriginLocations: RateLocation[],
    protected excludedDestinationLocations: RateLocation[],
  ) {
    super(
      id,
      discriminator,
      location,
      comment,
      rate,
      parent,
      excludedOriginLocations,
      excludedDestinationLocations,
    );
  }

  public getMinPrice(): number {
    return this.minPrice;
  }

  public setMinPrice(param: number): void {
    this.minPrice = param;
  }

  public getWeightPrice(): number {
    return this.weightPrice;
  }

  public setWeightPrice(param: number) {
    this.weightPrice = param;
  }

  public getMeasurementPrice(): number {
    return this.measurementPrice;
  }

  public setMeasurementPrice(param: number) {
    this.measurementPrice = param;
  }

  public getBlPrice(): number {
    return this.blPrice;
  }

  public setBlPrice(param: number) {
    this.blPrice = param;
  }

  public getClone(): RateLocation {
    return RateLocationMapper.map({
      id: this.getId(),
      discriminator: this.getDiscriminator(),
      location: LocationMapper.map(this.getLocation()),
      comment: this.getComment(),
      rate: RateMapper.map(this.getRate()),
      weightPrice: this.getWeightPrice(),
      measurementPrice: this.getMeasurementPrice(),
      parent: this.getParent(),
      excludedOriginLocations: this.getExcludedOriginLocations(),
      excludedDestinationLocations: this.getExcludedDestinationLocations(),
    });
  }
}
